import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Field, withFormik } from "formik";
import {
  InputDate,
  InputAutoComplete,
  InputText,
  InputSelect,
} from "@de-prado-dev/react-component-library";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "../sessionFilter/sessionFilter.data.form";
import {
  PageContainer,
  Header,
  HeaderTop,
  HeaderIcon,
  HeaderContent,
  Title,
  Subtitle,
  NewSessionButton,
  FilterAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionButton,
  AccordionCollapse,
  AccordionBody,
  FilterForm,
  FilterRow,
  FilterCol,
  FilterActions,
  FilterButtonPrimary,
  FilterButtonSecondary,
  SessionsGrid,
  SessionCard,
  SessionHeader,
  CourseIcon,
  CourseTitle,
  StatusBadge,
  SessionBody,
  InfoRow,
  InfoIcon,
  InfoLabel,
  InfoValue,
  SessionFooter,
  FooterInfo,
  ActionButton,
  PaginationContainer,
  PaginationInfo,
  PaginationButtons,
  PageButton,
  ExportButton,
} from "./sessionListNew.styled";

import "moment/locale/es";

import { Can } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";

const SessionListNewView = ({
  sessions,
  filters,
  showCompleted,
  onShowCompletedChange,
  onFilterSubmit,
  onCleanFilter,
  onFilterFinca,
  onNewSession,
  onViewSession,
  onEditSession,
  onConfirmSession,
  onDeleteSession,
  onDownloadDocument,
  currentPage,
  totalPages,
  totalDocs,
  onPageChange,
  handleSubmit,
  resetForm,
  courses,
  onExportToExcel,
}) => {
  const { t } = useTranslation();
  const getStatusBadge = (session) => {
    if (session.completed) {

      return (
        <StatusBadge $status="confirmed">
          {t("sessionListNew.status.confirmed")}
        </StatusBadge>
      );
    }

    return (
      <StatusBadge $status="pending">
        {t("sessionListNew.status.pending")}
      </StatusBadge>
    );
  };
  const renderListFinca = (item) => {
    return item.label;
  };

  const statuses = [
    { label: t("forms.session.statuses.completed"), code: true },
    { label: t("forms.session.statuses.pending"), code: false },
  ];

  return (
    <PageContainer>
      {/* Header */}
      <Header>
        <HeaderTop>
          <HeaderIcon>
            <i className="fas fa-chalkboard-teacher"></i>
          </HeaderIcon>
          <HeaderContent>
            <Title>{t("sessionListNew.title")}</Title>
            <Subtitle>{t("sessionListNew.subtitle")}</Subtitle>
          </HeaderContent>
          <Can do={USER_PERMISSIONS.CREATE_SESSION}>
            <NewSessionButton onClick={onNewSession}>
              <i className="fas fa-plus"></i>
              {t("sessionListNew.buttons.newSession")}
            </NewSessionButton>
          </Can>
          <Can do={USER_PERMISSIONS.EXPORT}>
            <ExportButton onClick={onExportToExcel}>
              <i className="fas fa-file-excel"></i>
              {t("forms.session.exportfileexcel")}
            </ExportButton>
          </Can>
        </HeaderTop>

        {/* Filter Accordion */}
        <FilterAccordion>
          <AccordionItem>
            <AccordionHeader>
              <AccordionButton
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#filterCollapse"
                aria-expanded="false"
                aria-controls="filterCollapse"
              >
                <i className="fas fa-filter"></i>
                {t("forms.session.filter")}
              </AccordionButton>
            </AccordionHeader>
            <AccordionCollapse
              id="filterCollapse"
              className="accordion-collapse collapse"
            >
              <AccordionBody>
                <FilterForm onSubmit={handleSubmit} autoComplete="off">
                  <FilterRow>
                    <FilterCol>
                      <Field
                        id="initDate"
                        className="form-control"
                        labelField={t("forms.session.table.heads.dateInit")}
                        name="initDate"
                        placeholder=""
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                        defaultHours={0}
                        defaultMinutes={0}
                      />
                    </FilterCol>
                    <FilterCol>
                      <Field
                        id="endDate"
                        className="form-control"
                        labelField={t("forms.session.table.heads.dateEnd")}
                        name="endDate"
                        placeholder=""
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                        defaultHours={23}
                        defaultMinutes={59}
                      />
                    </FilterCol>
                    <FilterCol>
                      <Field
                        id="centerUuid"
                        className="form-control"
                        labelField={t("forms.meeting.labels.farm")}
                        name="centerUuid"
                        component={InputAutoComplete}
                        fieldType="text"
                        onSearch={onFilterFinca}
                        optionValue="value"
                        optionLabel="label"
                        textButtonReset={t("clear")}
                        renderItems={renderListFinca}
                      />
                    </FilterCol>
                    <FilterCol>
                      <Field
                        id="employee"
                        className="form-control"
                        labelField={t("forms.meeting.labels.employee")}
                        name="employee"
                        placeholder=""
                        component={InputText}
                        fieldType="text"
                      />
                    </FilterCol>
                    <FilterCol>
                      <Field
                        id="courseUuid"
                        name="courseUuid"
                        component={InputSelect}
                        labelField={t("forms.meeting.labels.course")}
                        placeholder={t(
                          "forms.meeting.placeholders.selectCourse",
                        )}
                        optionLabel="name"
                        optionValue="uuid"
                        options={courses}
                        classNamePrefix="dark"
                        addOptionEmpty
                      />
                    </FilterCol>
                    <FilterCol>
                      <Field
                        id="completed"
                        name="completed"
                        component={InputSelect}
                        labelField={t("forms.meeting.labels.status")}
                        placeholder={t(
                          "forms.meeting.placeholders.selectEstado",
                        )}
                        optionLabel="label"
                        optionValue="code"
                        options={statuses}
                        classNamePrefix="dark"
                        addOptionEmpty
                      />
                    </FilterCol>
                  </FilterRow>

                  <FilterActions>
                    <FilterButtonPrimary type="submit">
                      <i className="fas fa-search"></i>
                      {t("search") || "Buscar"}
                    </FilterButtonPrimary>
                    <FilterButtonSecondary
                      type="button"
                      onClick={() => onCleanFilter(resetForm)}
                    >
                      <i className="fas fa-trash"></i>
                      {t("forms.cleanFilter") || "Limpiar"}
                    </FilterButtonSecondary>
                  </FilterActions>
                </FilterForm>
              </AccordionBody>
            </AccordionCollapse>
          </AccordionItem>
        </FilterAccordion>
        {/* <div className="row mt-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className={
                  "btn btn-sm flex-grow-1 flex-md-grow-0 " +
                  (filters.completed === true
                    ? "btn-warning"
                    : "btn-outline-warning")
                }
                onClick={() => onFilterSubmit({ ...filters, completed: true })}
              >
                <i className="fas fa-check-circle"></i>{" "}
                {t("forms.session.buttons.completed")}
              </button>

              <button
                type="button"
                className={
                  "btn btn-sm flex-grow-1 flex-md-grow-0 " +
                  (filters.completed === false
                    ? "btn-success"
                    : "btn-outline-success")
                }
                onClick={() => onFilterSubmit({ ...filters, completed: false })}
              >
                <i className="fas fa-clock"></i>{" "}
                {t("forms.session.buttons.pending")}
              </button>
            </div>
          </div>
        </div> */}
      </Header>

      {/* Sessions Grid */}
      <SessionsGrid>
        {sessions && sessions.length > 0 ? (
          sessions.map((session) => (
            <SessionCard
              key={session.uuid}
              $completed={session.completed}
              onClick={() => onViewSession(session)}
            >
              <SessionHeader>
                <CourseIcon $completed={session.completed}>
                  <i className="fas fa-book"></i>
                </CourseIcon>
                <CourseTitle>
                  {session.meeting?.course?.name ||
                    session.meeting?.name ||
                    "N/A"}
                </CourseTitle>
                {getStatusBadge(session)}
              </SessionHeader>

              <SessionBody>
                <InfoRow>
                  <InfoIcon className="fas fa-calendar" />
                  <div>
                    <InfoLabel>
                      {t("sessionListNew.labels.sessionDate")}
                    </InfoLabel>
                    <InfoValue>
                      {moment(session.date).format("dddd, DD MMMM YYYY")}
                    </InfoValue>
                  </div>
                </InfoRow>

                <InfoRow>
                  <InfoIcon className="fas fa-user" />
                  <div>
                    <InfoLabel>{t("sessionListNew.labels.trainer")}</InfoLabel>
                    <InfoValue>{session.user?.name || "N/A"}</InfoValue>
                  </div>
                </InfoRow>

                <InfoRow>
                  <InfoIcon className="fas fa-map-marker-alt" />
                  <div>
                    <InfoLabel>{t("sessionListNew.labels.location")}</InfoLabel>
                    <InfoValue>
                      {session.meeting?.center?.name ||
                        session.meeting?.farm ||
                        "N/A"}
                    </InfoValue>
                  </div>
                </InfoRow>

                <SessionFooter>
                  {session.completed ? (
                    <FooterInfo>
                      <i className="fas fa-users"></i>
                      <span>{t("sessionListNew.labels.participants")}</span>
                      <strong>{session.employees?.length || 0}</strong>
                    </FooterInfo>
                  ) : (
                    <>
                      <FooterInfo>
                        <i className="fas fa-users"></i>
                        <span>{t("sessionListNew.labels.participants")}</span>
                        <strong>{session.employees?.length || 0}</strong>
                      </FooterInfo>
                      <FooterInfo>
                        <i className="fas fa-users"></i>
                        <span>{t("sessionListNew.labels.assistants")}</span>
                        <strong>{session.employees?.length - session.employeesNotSigned?.length|| 0}</strong>
                      </FooterInfo>
                    </>
                  )}

                  <FooterInfo>
                    <i className="fas fa-clock"></i>
                    <span>{t("sessionListNew.labels.duration")}</span>
                    <strong>{moment(session.date).format("HH:mm")}</strong>
                  </FooterInfo>
                </SessionFooter>
              </SessionBody>

              <SessionFooter>
                {!session.completed && (
                  <ActionButton
                    $variant="confirm"
                    onClick={(e) => {
                      e.stopPropagation();
                      onConfirmSession(session.uuid);
                    }}
                  >
                    <i className="fas fa-check"></i>
                    {t("sessionListNew.buttons.confirm")}
                  </ActionButton>
                )}
                {/* <ActionButton
                  $variant="view"
                  onClick={() => onViewSession(session)}
                >
                  <i className="fas fa-eye"></i>
                  {t("sessionListNew.buttons.view")}
                </ActionButton> */}
                {!session.completed && (
                  <ActionButton
                    $variant="edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditSession(session.uuid);
                    }}
                  >
                    <i className="fas fa-pen"></i>
                    {t("sessionListNew.buttons.edit")}
                  </ActionButton>
                )}
                <ActionButton
                  $variant="download"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDownloadDocument(session.uuid);
                  }}
                >
                  <i className="fas fa-file-download"></i>
                  {t("sessionListNew.buttons.downloadAsistance")}
                </ActionButton>
                {!session.completed && (
                  <ActionButton
                    $variant="delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSession(session.uuid);
                    }}
                  >
                    <i className="fas fa-trash"></i>
                    {t("sessionListNew.buttons.delete")}
                  </ActionButton>
                )}
              </SessionFooter>
            </SessionCard>
          ))
        ) : (
          <div
            style={{
              gridColumn: "1 / -1",
              textAlign: "center",
              padding: "40px",
            }}
          >
            <p>{t("sessionListNew.noSessions")}</p>
          </div>
        )}
      </SessionsGrid>

      {/* Paginación */}
      {/* {totalPages > 1 && ( */}
      <PaginationContainer>
        <PaginationInfo>
          {t("sessionListNew.pagination.showing")} {sessions.length}{" "}
          {t("sessionListNew.pagination.of")} {totalDocs}{" "}
          {t("sessionListNew.pagination.sessions")}
        </PaginationInfo>
        <PaginationButtons>
          <PageButton
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            $active={false}
          >
            <i className="fas fa-angle-double-left"></i>
          </PageButton>
          <PageButton
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            $active={false}
          >
            <i className="fas fa-angle-left"></i>
          </PageButton>

          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;
            // Mostrar solo algunas páginas alrededor de la actual
            if (
              page === 1 ||
              page === totalPages ||
              (page >= currentPage - 1 && page <= currentPage + 1)
            ) {
              return (
                <PageButton
                  key={page}
                  onClick={() => onPageChange(page)}
                  $active={currentPage === page}
                  disabled={currentPage === page}
                >
                  {page}
                </PageButton>
              );
            } else if (page === currentPage - 2 || page === currentPage + 2) {
              return <span key={page}>...</span>;
            }
            return null;
          })}

          <PageButton
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            $active={false}
          >
            <i className="fas fa-angle-right"></i>
          </PageButton>
          <PageButton
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            $active={false}
          >
            <i className="fas fa-angle-double-right"></i>
          </PageButton>
        </PaginationButtons>
      </PaginationContainer>
      {/* )} */}
    </PageContainer>
  );
};

SessionListNewView.propTypes = {
  sessions: PropTypes.array.isRequired,
  filters: PropTypes.object,
  showCompleted: PropTypes.bool,
  onShowCompletedChange: PropTypes.func,
  onFilterSubmit: PropTypes.func,
  onCleanFilter: PropTypes.func,
  onFilterFinca: PropTypes.func,
  onNewSession: PropTypes.func,
  onViewSession: PropTypes.func,
  onEditSession: PropTypes.func,
  onConfirmSession: PropTypes.func,
  onDeleteSession: PropTypes.func,
  onDownloadDocument: PropTypes.func,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalDocs: PropTypes.number,
  onPageChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  resetForm: PropTypes.func,
  courses: PropTypes.array,
};

const SessionListNewViewWithFormik = withFormik({
  mapPropsToValues: (props) => {
    if (props.filters) {
      return setInitialValues(props.filters);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props }) => {
    props.onFilterSubmit(values);
  },
  enableReinitialize: true,
  displayName: "SessionListNewForm",
})(SessionListNewView);

export default SessionListNewViewWithFormik;
